module.exports = __webpack_public_path__ + "img/daisy.be5030ca.webp";